import { getLiteral } from 'utils/getLiteral';

export const AUTOMATED_MARKETING_CAMPAIGN_STATUS = {
    DRAFT: 0,
    PUBLISHED: 7,
    STOPPED: 8,
};

const STATUS_LITERAL_KEYS = {
    [AUTOMATED_MARKETING_CAMPAIGN_STATUS.DRAFT]: 'label_marketing_campaigns_status_draft',
    [AUTOMATED_MARKETING_CAMPAIGN_STATUS.PUBLISHED]: 'label_marketing_campaigns_status_published',
    [AUTOMATED_MARKETING_CAMPAIGN_STATUS.STOPPED]: 'label_marketing_campaigns_status_paused',
};

export function normalizeAutomatedMarketingCampaignStatusId(value) {
    if (value === null || value === undefined || value === '') {
        return AUTOMATED_MARKETING_CAMPAIGN_STATUS.DRAFT;
    }

    const statusId = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(statusId)
        ? Math.trunc(statusId)
        : AUTOMATED_MARKETING_CAMPAIGN_STATUS.DRAFT;
}

export function getAutomatedMarketingCampaignStatusFilterOptions() {
    return Object.values(AUTOMATED_MARKETING_CAMPAIGN_STATUS).map((statusId) => ({
        label: getLiteral(STATUS_LITERAL_KEYS[statusId]),
        value: String(statusId),
    }));
}

export function getAutomatedMarketingCampaignStatusLabel(statusId) {
    const normalizedStatusId = normalizeAutomatedMarketingCampaignStatusId(statusId);
    const literalKey = STATUS_LITERAL_KEYS[normalizedStatusId];

    return literalKey ? getLiteral(literalKey) : String(normalizedStatusId);
}

export function getAutomatedMarketingCampaignStatusBadgeType(statusId) {
    switch (normalizeAutomatedMarketingCampaignStatusId(statusId)) {
        case AUTOMATED_MARKETING_CAMPAIGN_STATUS.DRAFT:
            return 'outlined';
        case AUTOMATED_MARKETING_CAMPAIGN_STATUS.PUBLISHED:
            return 'semanticInfo';
        case AUTOMATED_MARKETING_CAMPAIGN_STATUS.STOPPED:
            return 'default';
        default:
            return 'default';
    }
}
